import React, { Component } from "react";
import "./assetsubtitleselection.css";

class AssetSubtitleSelection extends Component {

    handleStartChange = (index, value) => {
        const { assets = [], onChange } = this.props;

        const asset = assets[index];
        let start = parseInt(value, 10);

        if (isNaN(start)) {
            start = "";
        } else {
            if (start < 1)
                start = 1;

            if (start > asset.assubtitlecount)
                start = asset.assubtitlecount;
        }

        if (onChange) {
            onChange(index, {
                ...asset,
                start: start
            });
        }
    };

    handleEndChange = (index, value) => {

        console.log("on change", index,value)
        const { assets = [], onChange } = this.props;

        const asset = assets[index];
        let end = parseInt(value, 10);
        

        if (isNaN(end)) {
            end = "";
        } else {
            if (end < 1)
                end = 1;

            if (end > asset.assubtitlecount)
                end = asset.assubtitlecount;
        }

        if (onChange) {
            onChange(index, {
                ...asset,
                end: end
            });
        }
    };

    handleRemove = (index) => {
        if (this.props.onRemove) {
            this.props.onRemove(index);
        }
    };

    render() {
        const { assets = [] } = this.props;

        return (
            <div className="asset-subtitle-list">

                {/* Barre de titre */}
                <div className="asset-subtitle-list-header">
                    <div className="asset-subtitle-col-asset">
                        Asset
                    </div>

                    <div className="asset-subtitle-col-type">
                        Type
                    </div>

                    <div className="asset-subtitle-col-title">
                        Titre
                    </div>

                    <div className="asset-subtitle-col-start">
                        Début
                    </div>

                    <div className="asset-subtitle-col-end">
                        Fin
                    </div>

                    <div className="asset-subtitle-col-button">
                    </div>
                </div>

                {/* Liste scrollable */}
                <div className="asset-subtitle-list-content">

                    {assets.map((asset, index) => (
                        <div
                            className={
                                "asset-subtitle-list-row " +
                                (index % 2 === 1
                                    ? "asset-subtitle-list-row-alt"
                                    : "")
                            }
                            key={index}
                        >

                            <div className="asset-subtitle-col-asset">
                                {asset.asid}
                            </div>

                            <div className="asset-subtitle-col-type">
                                {asset.astype === 4
                                    ? "Original"
                                    : "Modifié"}
                            </div>

                            <div className="asset-subtitle-col-title">
                                {asset.astitle}
                            </div>

                            <div className="asset-subtitle-col-start">
                                <input
                                    style = {{backgroundColor:asset.start>asset.end?"#FF3030":"#606060"}}
                                    type="number"
                                    min="1"
                                    max={asset.assubtitlecount}
                                    value={asset.start ?? ""}
                                    onChange={(e) =>
                                        this.handleStartChange(
                                            index,
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                            <div className="asset-subtitle-col-end">
                                <input
                                    style = {{backgroundColor:asset.start>asset.end?"#FF3030":"#606060"}}
                                    type="number"
                                    min="1"
                                    max={asset.assubtitlecount}
                                    value={asset.end ?? ""}
                                    onChange={(e) =>
                                        this.handleEndChange(
                                            index,
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                            <div className="asset-subtitle-col-button">
                                <button
                                    className="asset-subtitle-remove-button"
                                    onClick={() =>
                                        this.handleRemove(index)
                                    }
                                >
                                    -
                                </button>
                            </div>

                        </div>
                    ))}

                </div>

            </div>
        );
    }
}

export default AssetSubtitleSelection;
